<template>
  <v-layout row wrap>
    <v-layout v-for="surveyInformation in dataSource.SurveyInformations" :key="surveyInformation.id">
        <v-flex xs4 class="pr-1" data-ui-component="Survey Type">
        <SummaryTile title="Survey Type">
            {{ surveyInformation.SurveyType }}
            <v-icon>content_paste</v-icon>
        </SummaryTile>
        </v-flex>
        <v-flex xs4 class="pr-1" data-ui-component="Survey Count">
        <SummaryTile title="Surveys">
            {{ surveyInformation.NumberOfSurveys }}
            <v-icon>content_paste</v-icon>
        </SummaryTile>
        </v-flex>
        <v-flex xs4 class="px-1" data-ui-component="First Survey Date">
        <SummaryTile title="From">
            {{ formatDate(surveyInformation.FirstSurveyDate) }}
            <v-icon>event</v-icon>
        </SummaryTile>
        </v-flex>
        <v-flex xs4 class="pl-1" data-ui-component="Last Survey Date">
        <SummaryTile title="To">
            {{ formatDate(surveyInformation.LastSurveyDate) }}
            <v-icon>event</v-icon>
        </SummaryTile>
        </v-flex>
        <v-flex xs4 class="px-1" data-ui-component="Specimens Count">
        <SummaryTile title="Specimens">
            {{ surveyInformation.NumberOfSpecimences }}
            <v-icon>content_paste</v-icon>
        </SummaryTile>
        </v-flex>
    </v-layout>    
  </v-layout>
</template>
<script>
  // import {
  //   numberWithCommas,
  // } from '@/helpers/numbers'
  import moment from 'moment'
  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'
  // import {
  //   min,
  //   max,
  // } from 'date-fns'
  import SummaryTile from '@/components/MonitoringFeature/DataSources/generic/SummaryTile'

  export default {
    components: {
      SummaryTile,
    },
    props: {
      dataSource: {
        type: Object,
        required: true,
      },
    },
    methods: {
      formatDate(dateValue){
        var dateFormat = moment(dateValue)
        return dateFormat ? dateFormat.format(prettyDateFormat) : 'Not Available'
      },
    },
  }
</script>